import React, { FC, useEffect, useState, useMemo, Fragment } from 'react'
import { observer } from 'mobx-react'
import { menuMobx, cartMobx, restaurantConfig, storeMobx } from 'restaurant'
import { buyTogetherMobx, decorationMobx, themeMobx } from '@mobxStore'
import productStyleController from '@ctrls/productStyleController'
import { debounce as _debounce } from '@dt/fe-utils/dist/lodash'
import { Empty, WaterfallSkeleton } from '@cps'
import ProductItem from '../ProductItem'
import { deepClone } from '@dt/fe-utils'
import './index.scss'

import noMealImg from '@img/no-meal.png'

interface IProps {
  lazy?: boolean;
  products?: IViewProduct[];
  selectCategoryNo?: string;
}

// 存储计算结果
let lineToResult = {}
/** 瀑布流计算定时器 */
let waterfallTimer
/** 瀑布流计算超过5次停掉 */
let calcStep = 0

const WaterfallTemplate: FC<IProps> = ({ lazy = true, products: _products }) => {
  const isBuyTogether = !!Config.buyTogetherId
  const [products, setProducts] = useState([])
  const [productStyleMap, setProductStyleMap] = useState({} as {
    [no: string]: {
      left: number;
      top: number;
    };
  })
  const [height, setHeight] = useState(420)
  const displayMode = 'waterfall'

  const hashProduct = useMemo(() => {
    const channelEatType = storeMobx.info.storeId + restaurantConfig.mpc.channel + restaurantConfig.mpc.eatType
    return channelEatType + products.map(p => p.no).join('')
  }, [products])
  const calcWaterfall = () => {
    clearTimeout(waterfallTimer)
    if (displayMode !== restaurantConfig.displayMode) return
    const productsSolts = deepClone(products)
    const payload = productStyleController.waterfall(productsSolts, lazy, 'no', 'decorateProduct')
    if (payload) {
      const { styleMap, height } = payload
      lineToResult[hashProduct] = payload
      setProductStyleMap(styleMap)
      setHeight(height)
    } else {
      if (calcStep <= 5) {
        setProductStyleMap({})
        waterfallTimer = setTimeout(() => {
          calcWaterfall()
        }, 300)
        ++calcStep
      }
    }
  }

  useEffect(() => {
    if (products.length && hashProduct) {
      if (lineToResult[hashProduct]) {
        setProductStyleMap(lineToResult[hashProduct].styleMap)
        setHeight(lineToResult[hashProduct].height)
      } else {
        setTimeout(() => {
          calcWaterfall()
        }, 300)
      }
    }
  }, [products, hashProduct])

  useEffect(() => {
    setProducts(productStyleController.setProductImgHeight(_products))
  }, [_products])

  useEffect(() => {
    if (restaurantConfig.displayMode !== 'waterfall') {
      clearTimeout(waterfallTimer)
    }
    return () => {
      productStyleController.clearWaterfallData()
      clearTimeout(waterfallTimer)
    }
  }, [restaurantConfig.displayMode])

  useEffect(() => {
    lineToResult = {}
    productStyleController.clearWaterfallData()
    calcStep = 0
  }, [])

  return (
    <>
      {
        menuMobx.isLoading ? <WaterfallSkeleton /> : products.length ? ( // 且有餐品
          <div className='product-list-content'>
            {/* <p className='title'>{selectCategoryNo ? productMobx.categoryNoToCategoryMap[selectCategoryNo].name : i18n.t('common.meals')}</p> */}
            <div className='decorateProduct-waterfall-template' style={{ height }}>
              {
                products.map((product, i) => {
                  const count = isBuyTogether ? buyTogetherMobx.productNoToCntMapForMenu?.[product.no] || 0 : cartMobx.cartResult?.productNoToCntMap?.[product.no] || 0
                  return (
                    <Fragment key={i}>
                      <ProductItem
                        mealDecorates={decorationMobx.mealDecorates || {} as TMealCommonDecorates}
                        style={productStyleMap[product.no] || { visibility: 'hidden' }}
                        key={product.no}
                        product={product}
                        count={count}
                        sourceName='decorateProduct'
                        backgroundMode={themeMobx.data.backgroundMode}
                      />
                    </Fragment>
                  )
                })
              }
            </div>
          </div>
        ) : ( // 无餐品
          <Empty
            msg={themeMobx?.data?.abnormalStateSetting?.[0]?.subName || ''}
            iconType='dicon'
            iconName={themeMobx?.data?.abnormalStateSetting[0]?.icon}
            picUrl={themeMobx?.data?.abnormalStateSetting[0]?.pic || noMealImg}
            height='55vh'
          />
        )
      }
    </>
  )
}
export default observer(WaterfallTemplate)
